import { PointsRange } from './PointsRange';

type IResults = {
    [range in PointsRange]: { title: string; description?: string };
};

export const Results: IResults = {
    [PointsRange.First]: {
        title: 'Congratulations! You seem to have no problems with drinking alcohol.',
    },
    [PointsRange.Second]: {
        title: 'Your results indicate smaller issues with drinking.',
        description:
            'You may be drinking slightly more than it is recommended. You should consider your approach to drinking alcohol and how it affects your life.',
    },
    [PointsRange.Third]: {
        title: 'Your results indicate higher issues with drinking.',
        description: 'Your drinking habits may negatively affect your life quality. We recommend you to consult your addiction with specialist.',
    },
    [PointsRange.Fourth]: {
        title: 'Your results indicate addiction to alcohol.',
        description: 'You definitely have a serious addiction to alcohol. You should look for a professional help.',
    },
};
